import { LiveChatWidget } from '@livechat/widget-react';

import './LiveChat.css';

interface LiveChatProps {
  isVisible: boolean;
  onClose: () => void;
  customVariables?: Record<string, string>;
}

export function LiveChat({ isVisible, onClose, customVariables }: LiveChatProps): JSX.Element {
  return (
    <LiveChatWidget
      license={process.env.REACT_APP_LIVE_CHAT_LICENSE_KEY}
      visibility={isVisible ? 'maximized' : 'hidden'}
      onVisibilityChanged={(event) => {
        if (event.visibility === 'hidden') {
          onClose();
        }
      }}
      sessionVariables={customVariables}
    />
  );
}
